'use strict';

import React, { Component } from 'react'

import _ from 'lodash'

import Layout from '@Layout/BackOffice'

import getFormData from '@/Form/Functions/getFormData'
import FileInputV2 from '@/Form/toolkit/FileInputV2'

import Loader from '@Pure/Loader'

import bemit from '@function/bemit'

const { app, moment, qwest } = window;

export default class TPEimportPage extends Component
{
	state =
	{
		form_data: { },

		status_messages: { }
	};

	UNSAFE_componentWillMount ()
	{
		var component = this, props = this.props;

		app.resetFunctions();
	}

	handleFileChange = (e, data) =>
	{
		const component = this, props = this.props, state = this.state;

		let name = data.name;

	// Upload files
		state.form_data['__files-' + name] = (state.form_data['__files-' + name] || [])
		.filter(function (file)
		{
			return file.form_name !== data.name;
		});

		if (data && data.value instanceof Array && data.value[0])
		{
			state.form_data['__files-' + name].push(data.value[0]);
		}

	// Upload infos
		state.form_data[name] = (state.form_data[name] || [])
		.filter(function (file)
		{
			return file.form_name !== data.name;
		});

		if (data && data.value instanceof Array && data.value[0])
		{
			let infos = _.cloneDeep(data.value[0]);

			delete infos.file;
			delete infos.pdf;
			delete infos.image;

			state.form_data[name].push(infos);
		}

		component.setState(
		{
			form_data: state.form_data
		});
	}

	import = (e) =>
	{
		const component = this, props = this.props, state = this.state;

		const form_data = getFormData({ state: state.form_data });

		component.setState({ processing: true });

		qwest.post('/import/tpe-file', form_data)
		.then(function (xhr, response)
		{
			component.setState(
			{
				processing: false,

				update_status: { },

				export_url: response.pathname,

				info: 'Traitement terminé, le nouveau fichier est disponible.',
				error: undefined,
				warning: undefined,
				statement: undefined
			});
		})
		.catch(function (error, xhr, response)
		{
			console.error(response?.error || response?.raw || error);

			component.setState(
			{
				processing: false,

				update_status: { error: response?.error },

				status_messages: response?.fields || { }
			});
		});
	}

	render ()
	{
		const component = this, props = this.props, state = this.state;

		let validate_btn_modifiers = ['extra'], dl_btn_modifiers = ['extra', 'blue'];

		if (state.export_url || !state.form_data['tpe_import']?.length > 0)
		{
			validate_btn_modifiers.push('disabled');
		}

		if (!state.export_url)
		{
			dl_btn_modifiers.push('disabled');
		}

		const process_loader = state.processing === true ?
		(
			<Loader className="c-loader" bemit={ ['white', 'bg-primary'] } />
		)
		: undefined;

		var output =
		(
			<Layout history={ props.history } page_title="Export des commandes">

				<div className="page-content">

					<div className="o-grid-2">

						<div className="o-grid__item">
							<FileInputV2 data={ state.form_data }
								onChange={ component.handleFileChange }
								status={ state.status_messages }
								name="tpe_import"
								button_txt="Sélection du fichier TPE">
							</FileInputV2>
						</div>

					</div>

					<div className="o-content u-margin-top-20">

						<a className={ bemit('c-btn', validate_btn_modifiers) }
							target="_blank" rel="noreferrer"
							onClick={ validate_btn_modifiers.includes('disabled')
								? undefined : component.import
							}>
							Importer le fichier TPE
							{ process_loader }
						</a>

					</div>

					<div className="o-content u-margin-top-20">

						<a className={ bemit('c-btn', ['blue']
								.concat(dl_btn_modifiers))
							}
							href={ state.export_url } target="_blank" rel="noreferrer">
							Télécharger l'export comptabilité
						</a>

					</div>

				</div>

			</Layout>
		);

		return output;
	}
}